/* Reference-style WhatsApp assistance drawer: one delayed auto-open per session. */
(() => {
  const init = () => {
    const dialog = document.querySelector('[data-wei-inquiry-popup]');
    const launcher = document.querySelector('[data-wei-chat-launcher]');
    if (!dialog || !launcher || dialog.dataset.ready || typeof dialog.show !== 'function') return;
    dialog.dataset.ready = 'true';
    const key = 'wei-inquiry-prompt-v2';
    const seen = () => { try { return sessionStorage.getItem(key) === 'shown'; } catch { return dialog.dataset.shown === 'true'; } };
    const markSeen = () => { dialog.dataset.shown = 'true'; try { sessionStorage.setItem(key, 'shown'); } catch {} };
    const delay = Math.max(5, Math.min(90, Number(dialog.dataset.delay) || 5)) * 1000;
    const started = Date.now();
    let timer;
    const open = (automatic = false) => {
      if (dialog.open) return;
      if (automatic) markSeen();
      dialog.show();
      dialog.querySelector('#wei-inquiry-popup-title')?.focus({ preventScroll: true });
    };
    const anotherDialog = () => [...document.querySelectorAll('dialog, [role="dialog"]')].some(el => el !== dialog && ((el.tagName === 'DIALOG' && el.open) || (el.getAttribute('aria-modal') === 'true' && el.getBoundingClientRect().width > 0)));
    const activeField = () => document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
    const attempt = () => {
      if (!dialog.isConnected || seen() || dialog.open) return;
      if (Date.now() - started < delay || document.visibilityState !== 'visible' || activeField() || anotherDialog() || document.body.classList.contains('templaza-mobilemenu-opened')) {
        timer = setTimeout(attempt, 1000);
        return;
      }
      open(true);
    };
    launcher.addEventListener('click', () => open());
    dialog.querySelectorAll('[data-wei-popup-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('keydown', event => { if (event.key === 'Escape') dialog.close(); });
    dialog.querySelector('[data-wei-chat-form]')?.addEventListener('submit', () => { markSeen(); dialog.close(); });
    dialog.querySelector('[data-wei-popup-cta]')?.addEventListener('click', () => { markSeen(); dialog.close(); });
    if (!seen()) timer = setTimeout(attempt, delay);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(dialog)) { clearTimeout(timer); if (dialog.open) dialog.close(); } });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
